import React from 'react'
import Style from './../profile/__profile.module.css';
/*
    - ihoDesignSystem
*/
import { Alert, Box, Button, Container, Drawer, Dropdown, Grid, Image, Modal, List, Link, TextField, Typography } from '@iho-design-system/Loader';
import { useLocation, NavLink } from "react-router-dom";

export default function Tabs() {
    /*
        - tabLocation
    */
    const location = useLocation();
    let baseActive,
    bossActive,
    officerActive,
    passActive,
    uploadActive;

    switch (location.pathname) {
        case '/profile/base-info':
            bossActive = '';
            officerActive = '';
            passActive = '';
            uploadActive = '';
            baseActive = 'active';
            break;
        case '/profile/boss-info':
            bossActive = 'active';
            officerActive = '';
            passActive = '';
            uploadActive = '';
            baseActive = '';
            break;
        case '/profile/officer-info':
            bossActive = '';
            officerActive = 'active';
            passActive = '';
            uploadActive = '';
            baseActive = '';
            break;
        case '/profile/change-pass':
            bossActive = '';
            officerActive = '';
            passActive = 'active';
            uploadActive = '';
            baseActive = '';
            break;
            case '/profile/upload-license':
                bossActive = '';
                officerActive = '';
                passActive = '';
                uploadActive = 'active';
                baseActive = '';
                break;

        default:
            break;
    }


    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>
                        <List
                            className={`d-flex justify-content-center pointer`}>
                            <List.Item className={`mx-md`}>
                                <NavLink
                               
                                    to='/profile/base-info'>
                                    <Typography
                                     ms={{
                                        fontSize:'14px'
                                    }}
                                        className={`${Style[baseActive]} p-md px-lg  rounded-sm`}>
                                        اطلاعات پایه
                                    </Typography>
                                </NavLink>
                            </List.Item>
                            <List.Item className={`mx-md`}>
                                <NavLink
                               
                                    to='/profile/boss-info'>
                                    <Typography
                                     ms={{
                                        fontSize:'14px'
                                    }}
                                        className={`${Style[bossActive]} p-md px-lg rounded-sm`}>
                                        اطلاعات مدیرعامل
                                    </Typography>
                                </NavLink>
                            </List.Item>
                            <List.Item className={`mx-md`}>
                                <NavLink
                                
                                    to='/profile/officer-info'>
                                    <Typography
                                     ms={{
                                        fontSize:'14px'
                                    }}
                                        className={`${Style[officerActive]} p-md px-lg rounded-sm`}>
                                        اطلاعات مسئول
                                    </Typography>
                                </NavLink>
                            </List.Item>
                           
                            <List.Item className={`mx-md`}>
                                <NavLink
                               
                                    to='/profile/upload-license'>
                                    <Typography
                                     ms={{
                                        fontSize:'14px'
                                    }}
                                        className={`${Style[uploadActive]} p-md px-lg rounded-sm`}>
                                        بارگزاری مجوزات
                                    </Typography>
                                </NavLink>
                            </List.Item>
                            <List.Item className={`mx-md`}>
                                <NavLink
                                
                                    to='/profile/change-pass'>
                                    <Typography
                                    ms={{
                                        fontSize:'14px'
                                    }}
                                        className={`${Style[passActive]} p-md px-lg rounded-sm`}>
                                        تغییر رمز عبور
                                    </Typography>
                                </NavLink>
                            </List.Item>

                        </List>
                        <Box
                            className={`my-sm mb-0 divider-horizontal divider-light`} />
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    )
}
